import axios, { AxiosResponse } from "axios";
import { NotificationAlert } from "../models/notifications.model";
import { NotificationsFilter } from "../models/notificationsFilter.model";
import { General } from "./general";


export function NotificationsService(props?: any) {
    const getNotifications = async (filter?: NotificationsFilter): Promise<AxiosResponse<NotificationAlert[]>> => {
        return axios.post<NotificationAlert[]>(`${General.API_URL}/GetNotifications`, filter);
    }

    const addNotification = async (notification: NotificationAlert): Promise<AxiosResponse<NotificationAlert>> => {
        return axios.post<NotificationAlert>(`${General.API_URL}/AddNotification`, notification);
    }

    const updateNotification = async (notification: NotificationAlert): Promise<AxiosResponse<NotificationAlert>> => {
        return axios.post<NotificationAlert>(`${General.API_URL}/UpdateNotification`, notification);
    }

    return (
        {
            getNotifications,
            addNotification,
            updateNotification
        }
    );
}
